import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	maxStockNum: ForNodeType<InputMaybe<number> | undefined> | undefined;
	onSetViewModel: (values: { key: "maxStockNum"; value: ForNodeType<InputMaybe<number> | undefined> }[]) => void;
};

export const useOptionMaxStockNum = ({ maxStockNum, onSetViewModel }: Props) => {
	const isEdited = maxStockNum?.isEdited ?? false;
	const hasError = maxStockNum?.error !== undefined;

	const onSetMaxStockNum = (input: number | undefined) => {
		onSetViewModel([{ key: "maxStockNum", value: { isEdited: true, value: input } }]);
	};

	return {
		isEdited,
		hasError,
		maxStockNum,
		onSetMaxStockNum,
	};
};
